import { useContext } from 'react';

import { AnnotationsIconImagesContext } from '../contexts/AnnotationsIconImages.context.js';

export const useAnnotationsIconImages = () =>
  useContext(AnnotationsIconImagesContext);
